import { Trans, useLingui } from '@lingui/react/macro';
import { ArrowRight } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import { ComponentLocations } from 'src/analytics/trackingTypes';
import { LandingFooter } from 'src/apps/checkout/app/components/LandingFooter';
import { Button } from 'src/components';
import { AppPage } from 'src/components/AppPage';
import { Highlight } from 'src/components/Highlight';
import { ValueProps } from 'src/components/Offers/ValueProps';
import { Price } from 'src/components/Price';
import { PromotionCheckoutLink } from 'src/components/PromotionCheckoutLink';
import { SKU } from 'src/utils/skus';
import { URLS } from 'src/utils/urls/urls';
import { valueProps } from 'src/utils/valueProps';

export const ConnectLandingPage = () => {
  const { t } = useLingui();
  const buttonText = t`Subscribe to Connect`;

  return (
    <AppPage.Container className="flex min-h-[calc(100dvh-64px)] flex-col">
      <div
        data-cy="connect-landing-hero"
        className="mx-auto h-full max-w-l2xl flex-1 py-32 text-center ls:py-48 lm:py-64 ll:py-96"
      >
        <div className="flex flex-col items-center">
          <Typography
            variant="responsive-heading-xl"
            className="mb-48 text-pretty"
          >
            <Trans>
              Subscribe to <Highlight scale={150}>Connect</Highlight>
            </Trans>
          </Typography>

          <div className="mb-24 w-full text-left lm:mb-48">
            <ValueProps valueProps={valueProps.connect} />
          </div>

          <div className="flex flex-wrap items-center justify-center gap-24">
            <Button
              as="a"
              to={URLS.STORE_CONNECT_CHECKOUT}
              variant="primary"
              className="w-full ls:w-fit"
              data-cy="landing-next-step"
              analytics={{
                action: 'subscribe to connect',
                location: ComponentLocations.CHECKOUT.LANDING,
                text: buttonText,
              }}
            >
              <span>{buttonText}</span> <ArrowRight />
            </Button>
            <PromotionCheckoutLink
              componentLocation={ComponentLocations.CHECKOUT.LANDING}
            />
          </div>

          <Typography
            variant="interface-sm"
            leadingNone
            className="mt-24 lm:mt-48"
          >
            <span>
              <Trans>
                Connect costs <Price sku={SKU.connectMonthly} />
                /mo. <b>Cancel anytime.</b>
              </Trans>
            </span>
          </Typography>
        </div>
      </div>
      <LandingFooter
        heading={t`What do I get with Connect?`}
        buttonText={t`Subscribe to Connect`}
        linkTo={URLS.STORE_CONNECT_CHECKOUT}
        componentLocation={ComponentLocations.CHECKOUT.LANDING_BOTTOM}
      />
    </AppPage.Container>
  );
};
